import React from 'react';
import { LoginContainer } from '../../auth';
import { withSession } from '../../auth/serverSide';
import { MetaAttributes } from '../../head';

const LoginPage = () => {
  return (
    <>
      <MetaAttributes seoTitle="Login | Ollie" />
      <LoginContainer />
    </>
  );
};

export const getServerSideProps = withSession(async context => {
  return {
    props: {},
  };
});

LoginPage.displayName = 'LoginPage';

export default LoginPage;
